import React from 'react';

import { currentLocale, miniGazelle } from '../../../../../helpers';
import { psapRule } from '../../utils';

const Title = ({ title, customTitle, genericName, customDescription, data }) => (
    <div className="container text-center">
        <div className="col-md-10 offset-md-1">
            {(title || customTitle) && <h1>{customTitle || title}</h1>}
            {(genericName || customDescription) && (
                <p
                    className="series-introduction inner-content"
                    dangerouslySetInnerHTML={{
                        __html: customDescription || miniGazelle.label(`${genericName}_description`),
                    }}
                />
            )}
            {psapRule(data, currentLocale.get())}
        </div>
    </div>
);

export default Title;
